import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DataTable from './GridDataTable';
import tableConfig from '../config/vendorsTable';
import { PagerDefault as Pager } from 'rp-react-pagination';
import {
    updatePagerAndLotsFound,
    updateTableOnPageChange,
    initialTableUpdate
} from '../helpers/dispatchProps';

/**
 * Reducer state key
 * @type {string}
 */
const stateKey = 'sires';
/**
 * @type {number}
 */
const pagerLength = 5;

/**
 * Vendors page
 *
 * @param {{}} props
 * @constructor
 */
function Vendors({ onPageChange, onAfterUpdate }) {
    return (
        <div className="table__Vendors">
            <DataTable
                stateKey="sires"
                config={tableConfig}
                errorMessage="No vendors in our records for this sale"
                onMount={initialTableUpdate(tableConfig.url)}
                onAfterUpdate={onAfterUpdate}
            />
            <Pager
                onPageChange={onPageChange}
                stateKey={stateKey}
                pageSize={50}
                pagerLength={pagerLength}
                offsetRange={5}
            />
        </div>
    );
}

Vendors.propTypes = {
    /**
     * DataTable onAfterUpdate event handler
     * Dispatch prop
     */
    onAfterUpdate: PropTypes.func,
    /**
     * Pager onPageChange event handler
     * Dispatch prop
     */
    onPageChange: PropTypes.func,
};

/**
 * Create component properties based on app state
 * No state props for this component
 *
 * @returns {{}} Empty object
 */
function mapStateToProps() {
    return {};
}

/**
 * Create component callable properties
 *
 * @returns {{}} Properties
 */
function mapDispatchToProps(dispatch) {
    const onAfterUpdate = updatePagerAndLotsFound(stateKey, pagerLength);

    return {
        onAfterUpdate,
        onPageChange: updateTableOnPageChange(dispatch, stateKey, tableConfig.url, onAfterUpdate)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Vendors);



// WEBPACK FOOTER //
// ./src/js/containers/Vendors.js